import styled from 'styled-components/macro'
import { transparentize } from 'polished'

import { Props, StyledButtonLoadProps } from './@types'

export const Wrapper = styled.form<Props>`
  padding: 0 0 1.6rem;
  display: flex;
`

export const ButtonLoad = styled.button<StyledButtonLoadProps>`
  position: relative;

  margin: 0;
  padding: 1rem 1.4rem;

  height: fit-content;

  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  gap: 1.2rem;

  font-family: ${(props) => props.theme.font.family.default};
  font-weight: ${(props) => props.theme.font.weight.regular};

  font-size: 1.4rem;
  line-height: 1.43;
  letter-spacing: 0;

  text-decoration: none;

  color: ${(props) => props.theme.color.textPrimary};
  background-color: ${(props) => props.theme.color.buttonBg};

  border: 0.1rem solid;
  border-color: ${(props) => props.theme.color.buttonBg};
  border-radius: 0.8rem;

  transition: all 0.26s ease;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  overflow: hidden;
  outline: none;
  z-index: ${(props) => props.theme.zIndex.minimal};

  &:disabled {
    opacity: ${(props) => props.theme.opacity.opacity02};
  }

  &:hover:not([disabled]),
  &:focus:not([disabled]),
  &:active:not([disabled]) {
    box-shadow: 0 0 0 0.3rem ${(props) => transparentize(0.5, props.theme.color.buttonBg)};
  }
`

export const InputLoad = styled.input<Props>`
  display: none;
`
